import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from '@unite-us/app-components';
import { getDomainUrl } from '../../../../common/utils/Prd/domainUtils';

export const ActivationModal = forwardRef((
  {
    activate, customerName, domain, confirmationCallback,
  },
  ref,
) => (
  <Modal
    ref={ref}
    title={activate ? 'Reactivate this PRD' : 'Deactivate this PRD'}
    size="normal"
    actions={(
      <div className="flex flex-row justify-end gap-x-2">
        <Button
          label="Cancel"
          onClick={() => {
            if (ref.current) {
              ref.current.closeModal();
            }
          }}
        />
        <Button
          style={{
              backgroundColor: '#4467AB',
              color: 'white',
            }}
          label={activate ? 'Reactivate this PRD' : 'Deactivate this PRD'}
          onClick={() => {
            confirmationCallback();
            if (ref.current) {
              ref.current.closeModal();
            }
          }}
        />
      </div>
      )}
  >
    <div>
      <span>
        {activate ? 'Do you want to reactivate the following PRD?' : 'Do you want to deactivate the following PRD?'}
      </span>
      <div className="flex flex-col my-5">
        <span>
          <b className="mr-1">
            Customer name:
          </b>
          {customerName}
        </span>
        <span>
          <b className="mr-1">
            Domain URL:
          </b>
          {getDomainUrl(domain)}
        </span>
      </div>
      <span>
        {activate ?
            'This site will be accessible once reactivated. You can deactivate it anytime if needed.' :
            'This site will no longer be accessible once deactivated. You can reactivate it anytime if needed.'}
      </span>
    </div>
  </Modal>
));

ActivationModal.propTypes = {
  activate: PropTypes.bool.isRequired,
  customerName: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  confirmationCallback: PropTypes.func.isRequired,
};
